import React, { Component } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import { connect } from "react-redux";

import moment from "moment";

class StoreInfo extends Component {
  render() {
    const { language } = this.props;
    if (!this.props.store) return <></>;

    return (
      <>
        <List
          style={{
            width: "100%",
            marginTop: 0,
            padding: 0,
            paddingTop: 3,
            backgroundColor: "white",
          }}
        >
          <ListItem
            alignItems="flex-start"
            className="pt-1"
            disableGutters={true}
            style={{
              flexDirection: language == "arabic" && "row-reverse",
              marginLeft: 0,
              paddingRight: 0,
              paddingLeft: 15,
              paddingBottom: 4,
            }}
          >
            <ListItemAvatar>
              <Avatar
                variant="rounded"
                src={this.props.logo}
                style={{
                  width: 60,
                  height: 60,
                  marginBottom: 9,
                  marginRight: language == "arabic" && 30,
                }}
              />
            </ListItemAvatar>
            <ListItemText
              primary={this.props.name}
              className={language == "english" ? "ml-3" : "text-right mr-3"}
              secondary={
                <React.Fragment>
                  <Typography
                    component="span"
                    variant="body2"
                    color="textPrimary"
                  >
                    {language == "english" ? "Welcome back!" : "مرحبا بك"}
                    <p
                      style={{
                        color: "#565656",
                        fontSize: "0.8rem",
                        marginTop: 5,
                      }}
                    >
                      {language == "english"
                        ? "What would you like to order today?"
                        : "ما هو طلبك اليوم؟"}
                    </p>
                  </Typography>
                </React.Fragment>
              }
            />
          </ListItem>
        </List>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    labels: state.store.labels,
    store: state.store.store,
    productionSlots: state.store.store.production_slots,
    branch: state.branch,
  };
};

export default connect(mapStateToProps)(StoreInfo);
